import React, { useReducer, useState, useContext } from 'react';
import api from './ApiCall';
import { SALESEXECUTIVE_LIST, SALESEXECUTIVE_DETAILS, SalesExecutiveContext, CommonContext } from './../constant/ActionTypes';
import { salesexecutiveReducer } from './../reducer/salesexecutiveReducer';
import Loader from './../../common/Loader/Loader';

const initialState = {
    salesexecutiveList: [],
    salesexecutiveDetails: {}
}

const SalesExecutiveProvider = (props) => {
    const commonContext = useContext(CommonContext);

    const [salesexecutiveState, dispatch] = useReducer(salesexecutiveReducer, initialState);

    const [showLoader, setShowLoader] = useState(false);

    // get sales executive list
    const getSalesExecutiveList = (page=null, offset=null) => {
        let pageLink = '';
        if (page) {
            pageLink = `?page=${page}&itemSize=${offset}`;
        }

        api({ contentType: true, auth: true }).get(`SalesExecService/getAll/${pageLink}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: SALESEXECUTIVE_LIST,
                    payload: response.data.result && response.data.result.content ? response.data.result.content : response.data.result
                });
                commonContext.updatePagination(response.data.result);
                if (
                    !(response.data.result && response.data.result.length > 0) ||
                    !(response.data.result && response.data.result.content && response.data.result.content.length > 0)
                ) {
                    commonContext.updateLoaderMsg('No data found')
                }
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const clearSalesExecutiveList = () => {
        dispatch({
            type: SALESEXECUTIVE_LIST,
            payload: []
        });
    }

    // get sales executive detail
    const getSalesExecutiveDetails = (salesexecutive_id) => {
        api({ contentType: true, auth: true }).get(`SalesExecService/getDetails/${salesexecutive_id}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: SALESEXECUTIVE_DETAILS,
                    payload: response.data.result
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    // add sales executive
    const addSalesExecutive = (salesexecutivedetail) => {
        setShowLoader(true);
		let data = {
			firstname: salesexecutivedetail.firstname,
            lastname: salesexecutivedetail.lastname,
            phone: salesexecutivedetail.phone,
            email: salesexecutivedetail.email,
            country: salesexecutivedetail.country,
            city: salesexecutivedetail.city
        }
        api({ contentType: true, auth: true }).post('SalesExecService/add', data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getSalesExecutiveList(1, 25);
                commonContext.handleSnackbar(true, 'success', response.data.message);
            }
            if(response.data.status.toLowerCase() === 'failure'){
                getSalesExecutiveList(1, 25);
                commonContext.handleSnackbar(true, 'error', response.data.message);   
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
        });
    }
    
    // update sales executive list
    const updateSalesExecutiveDetails = (salesexecutivedetail,salesexecutive_id) => {
        setShowLoader(true);
        let data = {
            id: salesexecutive_id,
            firstname: salesexecutivedetail.firstname,
            lastname: salesexecutivedetail.lastname,
            email: salesexecutivedetail.email,
            phone: salesexecutivedetail.phone,
            country: salesexecutivedetail.country,
            city: salesexecutivedetail.city
        }
        api({ contentType: true, auth: true }).patch('SalesExecService/update', data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getSalesExecutiveList(1, 25);
                commonContext.handleSnackbar(true, 'success', response.data.message);
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
        });
    }

    // delete sales executive
    const deleteSalesExecutive = (salesexecutive_id) => {
        setShowLoader(true);
        api({ contentType: true, auth: true }).patch(`SalesExecService/delete/${salesexecutive_id}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
				getSalesExecutiveList(1, 25);
                commonContext.handleSnackbar(true, 'success', 'Sales Executive deleted Successfully');
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
        });
    }

    const setTableFilters = (objData) => {
        dispatch({
            type: SET_TABLE_FILTERS,
            payload: objData
        });
    }

    return (
        <SalesExecutiveContext.Provider
            value={{
                ...salesexecutiveState,
                getSalesExecutiveList: getSalesExecutiveList,
                getSalesExecutiveDetails: getSalesExecutiveDetails,
                updateSalesExecutiveDetails: updateSalesExecutiveDetails,
                deleteSalesExecutive: deleteSalesExecutive,
                addSalesExecutive: addSalesExecutive,
                setTableFilters: setTableFilters,
                clearSalesExecutiveList: clearSalesExecutiveList
            }}
        >
            {props.children}
            {showLoader && <Loader onlyLoading />}
        </SalesExecutiveContext.Provider>
    );
}

export default SalesExecutiveProvider;



// WEBPACK FOOTER //
// ./contexts/provider/SalesExecutiveContext.js